import React,{useEffect} from 'react'
import './index.scss'
import dicon from '@/assets/images/d.png'
import picon from '@/assets/images/p.png'
// import qxImg from '@/assets/images/qx.png'
// import ymImg from '@/assets/images/ym.png'
// import yyImg from '@/assets/images/yy.png'
// import sdImg from '@/assets/images/sd.png'
import rightbtn from '@/assets/images/rightbtn.png'
// import fcImg from '@/assets/images/fc.png'
// import fzxImg from '@/assets/images/fzx.png'
import call from '@/assets/images/call.png'
import {connect} from 'react-redux'
// import { getLocationSearch } from '@/utils/utils'
// import ninehImg from '@/assets/images/900.jpg'
// import hhImg from '@/assets/images/hh.png'
// import tgImg from '@/assets/images/tg.png'
import {setTit} from '@/utils/settit'
import config from "@/config";
import { useParams } from 'react-router-dom';
import tgImg from "@/assets/images/tg.png";
import qszxImg from "@/assets/images/qszx.jpg";
import ddcxImg from "@/assets/images/ddcx.jpg";
import ydrdImg from "@/assets/images/ydrd.jpg";
import qxImg from "@/assets/images/qx.png";
import freeGoImg from "@/assets/images/free_go.jpg";


const mapStateToProps = (state) => ({
  tenant : state.getIn(['tenantReducer','tenant'])
})
const HhForDiDi = (props) => {
let tag = {
    62580:{appName:"62580网约版司机端",companyName:"强生致行互联网科技（上海）有限公司",img:qszxImg},
    ddcx:{appName:"叮叮出行",companyName:"重庆庞大叮叮科技有限公司南京分公司",img:ddcxImg},
    ydyc:{appName:"悦道用车",companyName:"上海美跃信息技术有限公司",img:ydrdImg},
    qxcx:{appName:"前行出行",companyName:"前行无限(天津)科技有限公司",img:qxImg},
    tgcx:{appName:"同港出行",companyName:"重庆渐臻科技有限公司",img:tgImg},
  }
  const params = useParams();
  const routeTag = params.tag;
  let LOGO_IMG = config.LOGO_IMG
  let appName = setTit()

  if(routeTag &&tag[routeTag]){
    appName = tag[routeTag].appName
    LOGO_IMG = tag[routeTag].img
  }

  if(window.location.hostname === 'app-web.hycx.com'){
    appName = 'FreeGo司机端'
    LOGO_IMG = freeGoImg
  }

  let {history} = props
  const handleGoSLine = () => {
    history.push('/sline')
  } 
  const handleGoPprivacy = () => {
    history.push('/pprivacy')
  }
  const handleGoCall = () => {
    history.push('/call')
  }
  useEffect(() => {
    document.title = `「${setTit()}」 安全中心`
    return () => {
      document.title = ''
    }
  }, [])
  return (
    <div className="hh-for-didi__box">
      <header>
        <img src={LOGO_IMG} alt=""/>
        {/* <img src={
          window.location.href.indexOf('tgh5') > -1 ? tgImg : (
            window.location.href.indexOf('hhh5') > -1 ? hhImg : (
              window.location.href.indexOf('jbh5') > -1 ? ninehImg : (
                window.location.href.indexOf('qxh5') > -1 ? qxImg: (
                  window.location.href.indexOf('ymh5') > -1 ? ymImg : (
                    window.location.href.indexOf('yyh5') > -1 ? yyImg : (
                      window.location.href.indexOf('sdh5') > -1 ? sdImg : (
                        window.location.href.indexOf('fch5') > -1 ? fcImg : (
                          window.location.href.indexOf('fzxh5') > -1 ? fzxImg :''
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        } alt="" /> */}
        <p>本次服务的司机、客服及安全保障均由「{appName}」提供</p>
      </header>
      <ul className="safety-list__box">
        <li onClick={handleGoSLine}>
          <em className="left_icon"><img src={dicon} alt=""/></em>
          <div>
            <h2>安全专线</h2>
            <h3>安全专线绿色通道，保障乘客安全</h3>
          </div>
          <i className="right_icon"><img src={rightbtn} alt=""/></i>
        </li>
        <li onClick={handleGoPprivacy}>
          <em className="left_icon"><img src={picon} alt=""/></em>
          <div>
            <h2>隐私号码保护</h2>
            <h3>虚拟中间号，保证车主、乘客安全</h3>
          </div>
          <i className="right_icon"><img src={rightbtn} alt=""/></i>
        </li>
      </ul>
      <footer>
        <button className="call_btn" onClick={handleGoCall}>
          <img src={call} alt=""/>
        </button>
        <em>一键报警</em>
      </footer>
    </div>
  )
}
export default connect(mapStateToProps)(HhForDiDi)
